module.exports = __webpack_public_path__ + "userCenter-change-password-ed0b7997.png";